import { defineMessages } from 'react-intl';

export default defineMessages({
  linesPerPage: {
    id: 'court_manager_page.assigned_claims_table.lines_per_page',
  },
  tableTile: {
    id: 'court_manager_page.assigned_claims_table.title',
  },
  claimNumber: {
    id: 'court_manager_page.assigned_claims_table_fields.claim_number',
  },
  policyNumber: {
    id: 'court_manager_page.assigned_claims_table_fields.policy_number',
  },
  claimNature: {
    id: 'court_manager_page.assigned_claims_table_fields.claim_nature',
  },
  lossDate: {
    id: 'court_manager_page.assigned_claims_table_fields.loss_date',
  },
  registrationNumber: {
    id: 'court_manager_page.assigned_claims_table_fields.registration_number',
  },
  assignedLawyer: {
    id: 'court_manager_page.assigned_claims_table_fields.assigned_lawyer',
  },
  status: {
    id: 'court_manager_page.assigned_claims_table_fields.status',
  },
  updateDate: {
    id: 'court_manager_page.assigned_claims_table_fields.update_date',
  },
  procesVerbalStatus: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_proces_verbal',
  },
  pending: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_pending',
  },
  validated: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_validated',
  },
  rejected: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_rejected',
  },
  toEdit: {
    id: 'lawyer_assignments_page.assigned_claims_table.status.to_edit',
  },
  toComplete: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_to_complete',
  },
  validatedWithoutContestation: {
    id:
      'lawyer_assignments_page.assigned_claims_table.status_validated_without_contestation',
  },
  appealStatus: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_appeal',
  },
  opposition: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_opposition',
  },
  assignedCourtManager: {
    id:
      'court_manager_page.assigned_claims_table_fields.assigned_court_manager',
  },
  claimNatureCorporeal: {
    id:
      'court_manager_page.assigned_claims_table_column.claim_nature.default_value',
  },
  assignToCourtManagerDialogContent: {
    id: 'court_manager_page.assign.confirmation_dialog_content',
  },
  assignConfirmTitle: {
    id: 'court_manager_page.assign.confirmation_dialog.confirm',
  },
  assignCancelTitle: {
    id: 'court_manager_page.assign.confirmation_dialog.cancel',
  },
  assignToCourtManagerTitle: {
    id: 'court_manager_page.assign.confirmation_dialog.title',
  },
  assignToCourtManagerInfoMessage: {
    id: 'court_manager_page.assign.confirmation_dialog.info_message',
  },
  summary: {
    id: 'court_manager_page.summary_button.text',
  },
  procesVerbal: {
    id: 'court_manager_legal_proceedings_page.proces.verbal.title',
  },
  judgementAdd: {
    id: 'court_manager_legal_proceedings_page.judgement_add_tab.title',
  },
  expertReport: {
    id: 'court_manager_legal_proceedings_page.expert_report_tab.title',
  },
  judgementOnTheMerits: {
    id:
      'court_manager_legal_proceedings_page.judgement_on_the_merits_tab.title',
  },
  appeal: {
    id: 'court_manager_legal_proceedings_page.appeal_tab.title',
  },
  edited: {
    id: 'lawyer_assignments_page.assigned_claims_table.status_modified',
  },
  applicationAnnulment: {
    id: 'manager_document_page.application_annulment_status',
  },
  arretAdd: {
    id: 'court_manager_legal_proceedings_page.arret_add_tab.title',
  },
  expertReportAppeal: {
    id: 'court_manager_legal_proceedings_page.expert_report_tab.title',
  },
  appealOnMerits: {
    id: 'court_manager_legal_proceedings_page.arret_on_merits_tab.title',
  },
});
